import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material';
import { useEffect, useState } from 'react';
import staticDataOfTp from './staticDataOfTP.json';

const TopicPulseMocups = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedRootId, setExpandedRootId] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const [expandedItems, setExpandedItems] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogTopics, setDialogTopics] = useState([]);
    const [dialogTitle, setDialogTitle] = useState("");

    const handleSeeMore = (topics, title) => {
        setDialogTopics(topics);
        setDialogTitle(title);
        setOpenDialog(true);
    };
    const handleCloseDialog = () => setOpenDialog(false);


    useEffect(() => {
        async function fetchData() {
            // setData(data1)
            setLoading(true);
            // let response = await axios.get(
            //     `${configUrl.AssessmentServer}/api/SwotAnalytics/getUserTopicsForTests/${0}`);
            // console.log(staticDataOfTp, "data hierarchy ", response);
            // const fetchedData = response?.data || [];
            const fetchedData = staticDataOfTp  // Array.isArray(response.data?.Data) ? response.data.Data : staticDataOfTp;
            setData(staticDataOfTp);
            // Expand first topic by default
            if (fetchedData.length > 0) {
                const firstRoot = fetchedData[0];
                setExpandedRootId(firstRoot.Id); // Expand first root topic

                // Also expand the first Level-2 topic if exists
                const firstSub = firstRoot.SubObjectList?.[0];
                if (firstSub && firstSub.Id) {
                    setExpandedItems([firstSub.Id]);
                }
            }
            setLoading(false);
        }
        fetchData()
    }, [])

    const toggleExpand = (id) => {
        setExpandedItems((prev) =>
            prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        );
    };

    const toggleRootExpand = (id) => {
        setExpandedRootId((prev) => (prev === id ? null : id));
    };

    const toggleSelection = (item) => {
        const exists = selectedItems.find((i) => i.Id === item.Id);
        if (exists) {
            setSelectedItems((prev) => prev.filter((i) => i.Id !== item.Id));
        } else {
            setSelectedItems((prev) => [...prev, item]);
        }
    };

    const renderSubLevel = (nodes, parentLevel = 1) => {
        if (!nodes || nodes.length === 0) return null;

        let level3Items = [];
        const MAX_VISIBLE_L3 = 8;
        return (
            <>
                {/* LEVEL 2 BUTTONS */}
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', marginTop: 2 }}>
                    {nodes.map((node) => {
                        const isSelected = selectedItems.some((i) => i.Id === node.Id);
                        const isExpanded = expandedItems.includes(node.Id);
                        const hasChildren = node.SubObjectList?.length > 0;

                        if (hasChildren && isExpanded) {
                            level3Items = [...level3Items, ...node.SubObjectList];
                        }

                        return (
                            <Box key={node.Id} sx={{ mb: 1 }}>
                                {hasChildren ? (
                                    <Button
                                        onClick={() => toggleExpand(node.Id)}
                                        sx={{
                                            backgroundColor: isExpanded
                                                ? 'rgba(230, 60, 56, 0.1)' // Active color
                                                : 'rgba(35, 196, 216, 0.1)', // Default color
                                            borderRadius: '0',
                                            padding: '10px 19px 10px 29px',
                                            fontFamily: 'Poppins',
                                            fontSize: '12px',
                                            textTransform: 'none',
                                            color: '#594e4e',
                                            '&:hover': {
                                                backgroundColor: isSelected
                                                    ? '#002147' // keep selected background
                                                    : 'rgba(35, 196, 216, 0.2)', // hover shade
                                                color: '#594e4e', // stay same even on hover
                                            },
                                        }}
                                    >
                                        {node.TopicName}
                                    </Button>
                                ) : (
                                    <Button
                                        onClick={() => toggleSelection(node)}
                                        sx={{
                                            backgroundColor: isSelected
                                                ? '#002147' // Selected color
                                                : 'rgba(35, 196, 216, 0.1)',
                                            borderRadius: '0',
                                            padding: '10px 19px 10px 29px',
                                            fontFamily: 'Poppins',
                                            fontSize: '12px',
                                            textTransform: 'none',
                                            color: isSelected ? '#fff' : '#594e4e',
                                        }}
                                    >
                                        {node.TopicName}
                                    </Button>
                                )}
                            </Box>
                        );
                    })}
                </Box>

                {/* LEVEL 3 AND LEVEL 4 BUTTONS */}
                {level3Items.length > 0 && (
                    <Box sx={{ mt: 1 }}>
                        <Divider sx={{ mb: 2, borderBottomWidth: '2px', borderColor: '#002147' }} />

                        {/* ===== LEVEL 3 ===== */}
                        {/* ===== LEVEL 3 ===== */}
                        {(() => {

                            // Split selected first
                            const selectedLevel3 = level3Items.filter((sub) =>
                                selectedItems.some((i) => i.Id === sub.Id)
                            );

                            const unselectedLevel3 = level3Items.filter(
                                (sub) => !selectedItems.some((i) => i.Id === sub.Id)
                            );

                            const MAX_TOTAL_VISIBLE = 8;

                            // First take selected
                            let finalLevel3List = [...selectedLevel3];

                            // If selected are less than 8 → add unselected to fill remaining slots
                            if (finalLevel3List.length < MAX_TOTAL_VISIBLE) {
                                const remainingSlots = MAX_TOTAL_VISIBLE - finalLevel3List.length;
                                finalLevel3List = [
                                    ...finalLevel3List,
                                    ...unselectedLevel3.slice(0, remainingSlots)
                                ];
                            }

                            // Determine if more items exist (only check unselected overflow)
                            const hasMore = finalLevel3List.length < level3Items.length;

                            return (
                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                    {finalLevel3List.map((sub) => {
                                        const isSelected = selectedItems.some((i) => i.Id === sub.Id);
                                        const hasLevel4 = sub.SubObjectList && sub.SubObjectList.length > 0;

                                        return (
                                            <Box key={sub.Id}>
                                                {/* LEVEL 3 BUTTON */}
                                                <Button
                                                    disabled={
                                                        hasLevel4
                                                            ? false
                                                            : sub.TotalTests === 0 || sub.TotalTests === sub.AssignedTests
                                                    }
                                                    onClick={() => toggleSelection(sub)}
                                                    sx={{
                                                        backgroundColor: isSelected
                                                            ? '#002147'
                                                            : 'rgba(35, 196, 216, 0.1)',
                                                        borderRadius: '0',
                                                        padding: '10px 19px 10px 29px',
                                                        fontFamily: 'Poppins',
                                                        fontSize: '12px',
                                                        textTransform: 'none',
                                                        color: isSelected ? '#fff' : '#594e4e'
                                                    }}
                                                >
                                                    {sub.TopicName}
                                                </Button>

                                                {/* ===== LEVEL 4 (selected first) ===== */}
                                                {hasLevel4 && (
                                                    <Box sx={{ mt: 1, ml: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                        {(() => {
                                                            const selectedL4 = sub.SubObjectList.filter((lvl4) =>
                                                                selectedItems.some((i) => i.Id === lvl4.Id)
                                                            );
                                                            const unselectedL4 = sub.SubObjectList.filter(
                                                                (lvl4) => !selectedItems.some((i) => i.Id === lvl4.Id)
                                                            );
                                                            const finalL4 = [...selectedL4, ...unselectedL4];

                                                            return finalL4.map((lvl4) => {
                                                                const isLvl4Selected = selectedItems.some((i) => i.Id === lvl4.Id);
                                                                return (
                                                                    <Button
                                                                        key={lvl4.Id}
                                                                        disabled={
                                                                            lvl4.TotalTests === 0 ||
                                                                            lvl4.TotalTests === lvl4.AssignedTests
                                                                        }
                                                                        onClick={() => toggleSelection(lvl4)}
                                                                        sx={{
                                                                            backgroundColor: isLvl4Selected
                                                                                ? '#002147'
                                                                                : 'rgba(35, 196, 216, 0.1)',
                                                                            borderRadius: '0',
                                                                            padding: '8px 15px',
                                                                            fontFamily: 'Poppins',
                                                                            fontSize: '11px',
                                                                            textTransform: 'none',
                                                                            color: isLvl4Selected ? '#fff' : '#594e4e'
                                                                        }}
                                                                    >
                                                                        {lvl4.TopicName}
                                                                    </Button>
                                                                );
                                                            });
                                                        })()}
                                                    </Box>
                                                )}
                                            </Box>
                                        );
                                    })}

                                    {/* Show More button only when overflow exists */}
                                    {hasMore && (
                                        <Button
                                            onClick={() => handleSeeMore(level3Items, 'Select Topics')}
                                            sx={{
                                                backgroundColor: 'rgba(255,165,0,0.2)',
                                                color: '#002147',
                                                fontFamily: 'Poppins',
                                                fontSize: '12px',
                                                borderRadius: '0',
                                                padding: '10px 19px 10px 29px',
                                                textTransform: 'none',
                                            }}
                                        >
                                            More...
                                        </Button>
                                    )}
                                </Box>
                            );
                        })()}


                    </Box>
                )}


            </>
        );
    };

    return (
        <div>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                {data?.map((node) => {
                    const isExpanded = expandedRootId === node.Id;
                    return (
                        <Button
                            key={node.Id}
                            variant={isExpanded ? 'contained' : 'outlined'}
                            color={isExpanded ? 'primary' : 'inherit'}
                            onClick={() => toggleRootExpand(node.Id)}
                            sx={{
                                borderRadius: '0',
                                padding: '10px 19px 10px 29px',
                                fontFamily: 'Poppins',
                                fontSize: '12px',
                                textTransform: 'none',
                                color: '#594e4e',
                                backgroundColor: isExpanded ? 'rgba(230, 60, 56, 0.1)' : '',
                                '&:hover': {
                                    backgroundColor: isExpanded
                                        ? 'rgba(230, 60, 56, 0.1)' // Same as selected background
                                        : 'rgba(230, 60, 56, 0.2)', // Slightly darker hover for unselected
                                },
                            }}
                        >
                            {node.TopicName}
                        </Button>
                    );
                })}
            </Box>
            <Divider sx={{ my: 2, borderBottomWidth: '2px', borderColor: '#002147' }} />
            {/* Level 2 (if root expanded) */}
            {expandedRootId && (
                <>
                    {/* <Typography variant="h6">Level 2</Typography> */}
                    {renderSubLevel(
                        data.find((n) => n.Id === expandedRootId)?.SubObjectList || [],
                        1
                    )}
                </>
            )}
            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                <DialogTitle sx={{
                    fontWeight: 600,
                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                    backgroundColor: "#0B3054", // dark blue
                    color: "#fff",
                    textAlign: "left",
                }}>
                    {dialogTitle}
                </DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {dialogTopics.map((topic) => {
                            const isSelected = selectedItems.some((i) => i.Id === topic.Id);
                            return (
                                <Button
                                    key={topic.Id}
                                    onClick={() => toggleSelection(topic)}
                                    sx={{
                                        backgroundColor: isSelected ? '#002147' : 'rgba(35,196,216,0.1)',
                                        color: isSelected ? '#fff' : '#594e4e',
                                        borderRadius: '0',
                                        padding: '10px 19px 10px 29px',
                                        fontFamily: 'Poppins',
                                        fontSize: '12px',
                                        textTransform: 'none',
                                        '&:hover': {
                                            backgroundColor: isSelected
                                                ? '#002147' // keep selected background
                                                : 'rgba(35, 196, 216, 0.2)', // hover shade
                                            color: '#594e4e', // stay same even on hover
                                        },
                                    }}
                                >
                                    {topic.TopicName}
                                </Button>
                            );
                        })}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}
                        sx={{
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                            color: '#002147',
                            border: 'solid 1px',
                            fontSize: '1.25rem',
                            textTransform: 'none'
                        }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default TopicPulseMocups;
